import { FC } from 'react'
import styled from 'styled-components'
import { SideBar } from 'widgets/Sidebar'

export const withSideBarHOC =
  (Component: FC<any>): FC<any> =>
  (props) =>
    (
      <SideBar>
        <ComponentContainer>
          <Component {...props} />
        </ComponentContainer>
      </SideBar>
    )

export const ComponentContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.backGroundColor};
  color: ${({ theme }) => theme.textColor};
`
